import React from "react";
import SideBar from "../SideBar/SideBar";
import Footer from "../Footer/Footer";
import "./Analytics.css";
import { Line } from "react-chartjs-2";
import Header from "../Header/Header";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { ChartLine, Clock, Calendar, CircleCheckBig } from "lucide-react";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const Analytics = () => {
  const data = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Views",
        data: [
          500, 700, 1200, 1500, 1800, 2200, 2600, 2900, 3200, 3500, 3800, 4200,
        ],
        borderColor: "#ff6803",
        backgroundColor: "#ff6803",
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { color: "#444" } },
    },
  };
  return (
    <div>
      <SideBar />
      <Header value={{ name: "Analytics" }} />
      <div className="analytics-content menu-card-con ">
        <div className="analytics-header">
          <h3>Analytics</h3>
          <input
            type="date"
            className="analytics-date-picker"
            defaultValue={new Date().toISOString().split("T")[0]}
          />
        </div>

        <div className="analytics-cards">
          <div className="analytics-card">
            <ChartLine className="icon mb-3" />
            <h5>Views</h5>
            <p>$50,000</p>
            <div class="View-card">
              <span>View All</span>
            </div>
          </div>

          <div className="analytics-card">
            <Calendar className="icon mb-3" />
            <h5>QR</h5>
            <p>1,200</p>
            <div class="View-card">
              <span>View All</span>
            </div>
          </div>

          <div className="analytics-card">
            <Clock className="icon mb-3 " />
            <h5>QR Rate</h5>
            <p>320</p>
            <div class="View-card">
              <span>View All</span>
            </div>
          </div>

          <div className="analytics-card">
            <CircleCheckBig className="icon mb-3" />
            <h5>Subscribers</h5>
            <p>$42</p>
            <div class="View-card">
              <span>View All</span>
            </div>
          </div>
        </div>
        <div className="analytics-graph">
          <div className="chart-container">
            <Line data={data} options={options} />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Analytics;
